import "./DockerFeed";
import "./GitHubFeed";
import "./MavenFeed";
import "./NpmFeed";
import "./NuGetFeed";
import "./HelmFeed";
import "./OciRegistryFeed";
import "./AwsElasticContainerRegistry";
import "./AzureContainerRegistry";
import "./GoogleContainerRegistry";
import "./S3Feed";
import "./GcsStorageFeed";
import "./ArtifactoryGenericFeed";
import feedTypeRegistry from "./feedTypeRegistry";
export default feedTypeRegistry;
